export default __webpack_public_path__ + "static/media/main-hero.ed325e33.png";